import React from 'react'
import { clients } from "../assets/data/clients";
import { Link } from 'react-router-dom';

const ClientComp = () => {
  return (
   <>
      <section className="client-page-data team-member client-comp">
        <div className="container">
          <div className="row mb-3">
            <div className="col-12">
              <div className="sec-heading">
                <h2 style={{color: "white"}}>Our Credentials</h2>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            {clients.slice(0,4).map((data, index) => {
              return (
                <div className="col-lg-3 col-md-4 col-sm-6 col-12 my-2">
                  <div target="_blank" className="client-box">
                    <div className="img-box">
                      <img src={data.img2} alt="team" className="img-fluid" />
                    </div>
                    <div className="content-box mt-2">
                      <p>{data.homeheading}</p>
                    </div>
                    <div className="img-box">
                      <img src={data.img1} alt="team" className="img-fluid" />
                    </div>
                   
                    {/* <div className="industry">
                      <p>{data.industry}</p>
                    </div> */}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="row mt-4">
            <div className="col-12">
                <div className="team-btn">
                    <button><Link to="/our-credentials">Know More</Link></button>
                </div>
            </div>
          </div>
        </div>
      </section>{" "}
   </>
  )
}

export default ClientComp;